import { Axios } from 'cms-api'
import { Trade } from '@public/Trade'
import { STRAPI_WIDGETS } from 'constants/common'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'
import { addError } from 'utils/rum'

export async function getStaticProps() {
  const navigationStaticProps = await prepareGetStaticNavigationProps()

  let marketplaceBrandsWidget = null
  try {
    const homepage = await Axios.client().getHomepage({
      populate: {
        widgets: {
          on: {
            [STRAPI_WIDGETS.BRANDS_WIDGET]: {
              populate: {
                brands: {
                  populate: '*',
                },
              },
            },
          },
        },
      } as never,
    })
    marketplaceBrandsWidget =
      homepage?.data?.widgets?.find(
        // eslint-disable-next-line no-underscore-dangle
        (widget) => widget.__component === STRAPI_WIDGETS.BRANDS_WIDGET
      ) ?? null
  } catch (error) {
    addError(error)
  }

  return {
    ...navigationStaticProps,
    props: {
      ...('props' in navigationStaticProps ? navigationStaticProps.props : {}),
      marketplaceBrandsWidget,
    },
  }
}

export default Trade
